<template>
  <div class="content-container" v-loading="loading">
    <ContentBox title="查看广告主账号" class="content-box">
      <el-form class="demo-ruleForm" ref="addForm" :model="addForm" label-width="90px" label-position="left">
        <el-form-item label="登录账号" prop="agentAccount">
          {{addForm.agentAccount}}
        </el-form-item>
        <el-form-item label="账号名称" prop="agentAccountName">
          {{addForm.agentAccountName}}
        </el-form-item>
        <el-form-item label="邮件地址" prop="email">
          {{addForm.email}}
        </el-form-item>
        <el-form-item label="广告主" prop="phone">
          {{addForm.partnerName}}
        </el-form-item>
        <el-form-item label="账号角色" prop="flag">
          <template v-if="addForm.flag === 0">管理员</template>
          <template v-else-if="addForm.flag === 1">操作员</template>
          <template v-else-if="addForm.flag === 2">业务员</template>
          <template v-else-if="addForm.flag === 3">数据员</template>
          <template v-else>财务</template>
        </el-form-item>
        <el-form-item label="状态" prop="disabled">
          <template v-if="addForm.disabled === 0">启用</template>
          <template v-else>禁用</template>
        </el-form-item>
      </el-form>
    </ContentBox>
    <ContentBox class="content-box">
      <el-button @click="handleQuit">
        <i class="icon-ios-undo"></i>返回列表
      </el-button>
    </ContentBox>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
export default {
  props: ['mode', 'id'],
  data() {
    return {
      loading: false,
      addForm: {
        agentAccount: '',
        agentAccountName: '',
        email: '',
        phone: '',
        flag: 0,
        disabled: 0
      }
    }
  },
  methods: {
    handleQuit() {
      this.$emit('go-back', false)
    },
    getAccAdDspCustomerDetail() {
      this.loading = true
      this.$service
        .getAccAdDspCustomerDetail({ agentAccountId: this.id })
        .then((data) => {
          this.addForm = data
          this.addForm.agentAccount = this.$decrypt(data.agentAccount)
          this.addForm.email = this.$decrypt(data.email)
          this.addForm.phone = this.$decrypt(data.phone)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  },
  created() {
    this.getAccAdDspCustomerDetail()
  }
}
</script>、
<style lang="stylus" scoped>
.content-container
  margin 16px
>>>.title
  padding-left 32px
>>>.content-box__main
  margin-left 32px
</style>
